
















































































import Vue from 'vue'

import SourceSelect from '@/components/source-select.vue'
import PublicationCard from '@/components/publication-card.vue'
import { SearchRequest } from '@/core/api/search'
import DatePicker from '@/components/date-picker.vue'

export default Vue.extend({
  components: {
    SourceSelect,
    PublicationCard,
    DatePicker,
  },
  data: () => ({
    showFullText: false,
    showDialog: false,
    loading: false,
    query: '*',
    dateStart: null as any,
    dateEnd: null as any,
    source: null as any,
    results: [],
    meta: null as any,
    pageSize: 20,
    page: 1,
  }),
  computed: {
    pageCount(): number {
      if (this.meta) {
        return Math.min(Math.floor(this.meta.total_results / this.pageSize) + 1, 500)
      }
      return 1
    },
    sourceName(): string {
      return this.source && this.source.name
    },
  },
  async created() {
    this.dateStart = this.$moment()
    this.dateEnd = this.$moment()
    await this.$store.dispatch('industries/FETCH')
    await this.$store.dispatch('levels/FETCH')
    await this.$store.dispatch('categories/FETCH')
    await this.$store.dispatch('countries/FETCH')
    await this.$store.dispatch('regions/FETCH')
    await this.$store.dispatch('districts/FETCH')
    await this.$store.dispatch('cities/FETCH')
  },
  methods: {
    search(): void {
      this.page = 1
      this.fetch()
    },
    fetch(): void {
      this.loading = true

      const request = new SearchRequest()
      request
        .send({
          query: this.query,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          sourceId: this.source && this.source.id,
          page: this.page,
          pageSize: this.pageSize,
        })
        .then(
          ({ data }) => {
            this.results = data.results
            this.meta = data.meta
          },
          () => {
            this.$toastError.fire({ title: 'Ошибка обработки запроса' })
          },
        )
        .finally(() => {
          this.loading = false
        })
    },
    onSourceClick(): void {
      this.showDialog = true
    },
    onSourceSelect(source): void {
      this.source = source
      this.showDialog = false
    },
  },
})
